// JS
import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
import { randomId } from '../shared/utils';

// SCSS
import '/node_modules/react-modal-video/scss/modal-video.scss';

// COMPONENT
export const HeroVideo = ({
  // Default Props
  gaBlockName,
  data,
  topMargin = true,
  showHeroVideo = true
}) => {
  const [isOpen, setOpen] = useState(false);
  const uniqueId = randomId();

  return (
    <section
      id={'hero-video-' + uniqueId}
      className={
        showHeroVideo
          ? topMargin
            ? 'my-24 lg:my-48'
            : 'mb-16 lg:mb-32'
          : 'hidden'
      }
    >
      {data &&
        data.map((video, index) => (
          <div key={index}>
            <ModalVideo
              url={video.seven_video_hero_url}
              autoplay
              isOpen={isOpen}
              onClose={() => setOpen(false)}
              channel="custom"
            />
            <div
              key={index}
              className={`relative z-0 bg-cover bg-center flex h-full items-end aspect-[64/95] md:aspect-[48/25] xl:aspect-[192/65]`}
              style={{
                backgroundImage: `url('${video.seven_video_hero_image}')`
              }}
              data-name={
                video.seven_video_hero_title +
                ' ' +
                video.seven_video_hero_sub_title
              }
              data-creative={gaBlockName}
              data-id={video.contentguid}
              data-position={'banner-slot-' + (index + 1)}
              data-type="banner"
            >
              <a
                alt={
                  video.seven_video_hero_title +
                  ' ' +
                  video.seven_video_hero_sub_title
                }
                className="after:absolute after:inset-0 after:z-10 after:w-full after:h-full hover:text-current"
                href={video.seven_video_hero_url_link}
                data-name={
                  video.seven_video_hero_title +
                  ' ' +
                  video.seven_video_hero_sub_title
                }
                data-creative={gaBlockName}
                data-id={video.contentguid}
                data-position={'button-slot-' + (index + 1)}
                data-type="banner-button"
              ></a>
              <div
                className={
                  'after:absolute after:inset-0 after:z-0 after:w-full after:h-full after:bg-gradient-to-t ' +
                  (video.seven_video_hero_white_black &&
                  video.seven_video_hero_white_black === 'true'
                    ? 'after:from-black/40 lg:after:from-black/20'
                    : 'after:from-white/50 lg:after:from-white/20')
                }
              ></div>
              <div
                className={
                  'absolute left-0 bottom-0 w-full my-10 lg:my-12 uppercase ' +
                  (video.seven_video_hero_white_black &&
                  video.seven_video_hero_white_black === 'true'
                    ? 'text-white'
                    : 'text-black')
                }
              >
                <div className="container mx-auto flex flex-col md:flex-row md:items-center md:justify-between">
                  <div className="text-lg lg:text-xl mb-10 md:mb-0">
                    <h2 className="font-bold tracking-widest mb-6 md:mb-8">
                      {video.seven_video_hero_sub_title}
                      <p className="font-base text-lg lg:!text-xl">
                        {video.seven_video_hero_title}
                      </p>
                    </h2>
                    {video.seven_video_hero_description}
                  </div>
                  <button
                    className="py-5 h-auto border-white text-center no-underline inline-block tracking-normal duration-200 cursor-pointer font-bold
                      lg:w-auto px-12 text-md text-white uppercase border border-solid bg-transparent transition ease-in-out hover:!text-black hover:!bg-white z-20 "
                    onClick={() => setOpen(true)}
                  >
                    {video.seven_video_hero_url_text}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
    </section>
  );
};
export default HeroVideo;
